import ReactApexChart from 'react-apexcharts'
import { profitChartData } from '../../../../../Data/Dashboard/DashboardCharts/DashboardCharts'

const ProfitChart = () => {
  return (
    <ReactApexChart options={profitChartData} series={profitChartData.series} type='bar' height={100} id="profit-chart" />
  )
}

export default ProfitChart